import { Tag } from 'antd'
import { WEEKDAY_LABEL } from '../constants'

type WeekdayTagListProps = {
  weekdays: number[]
  size?: 'sm' | 'lg'
}

export function WeekdayTagList({ weekdays, size = 'sm' }: WeekdayTagListProps) {
  if (!weekdays.length) {
    return <span className="text-sm text-gray-500">-</span>
  }

  return (
    <div className={size === 'lg' ? 'flex flex-wrap gap-3' : 'flex flex-wrap gap-2'}>
      {weekdays.map((day) => (
        <Tag
          key={day}
          className={
            size === 'lg'
              ? 'm-0 rounded-full px-3 py-1 text-sm'
              : 'm-0 rounded-full px-2'
          }
        >
          {WEEKDAY_LABEL[day] || day}
        </Tag>
      ))}
    </div>
  )
}
